import { Balance, BalanceItemType } from '../api/types'

export const balanceTypeFilter = (item: Balance) => {
  return (
    (['CC', 'Plaat', 'Slotplaat'] as BalanceItemType[]).indexOf(item.itemName) !== -1
  )
}
